import { render } from "./Edit.vue?vue&type=template&id=e4008548"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=e4008548&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__